// ========== Start Featured Testimonials Slider ==========
var slider = new KeenSlider("#testimonials__slider_2", {
  loop: true,
  slides: {
    origin: "center", // Center the active slide
    perView: 2.337, // Show half of the previous and next slides
    spacing: 20, // Adjust spacing between slides
  },
   breakpoints: {
    // Adjust for mobile screens
    "(max-width: 768px)": {
      slides: {
        perView: 1.4675, // Show only one slide on mobile
        spacing: 16, // Reduced spacing
      },
    },
  },
}, 
[
  navigation,
  (slider) => {
    let timeout;
    let mouseOver = false;

    function clearNextTimeout() {
      clearTimeout(timeout);
    }

    function nextTimeout() {
      clearTimeout(timeout);
      if (mouseOver) return;
      timeout = setTimeout(() => {
        slider.next();
      }, 10000);
    }

    slider.on("created", () => {
      slider.container.addEventListener("mouseover", () => {
        mouseOver = true;
        clearNextTimeout();
      });
      slider.container.addEventListener("mouseout", () => {
        mouseOver = false;
        nextTimeout();
      });
      nextTimeout();
    });

    slider.on("dragStarted", clearNextTimeout);
    slider.on("animationEnded", nextTimeout);
    slider.on("updated", nextTimeout);
  },
]);
// ========== End Featured Testimonials Slider ==========
